import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import Server from "../../Shared/Server";
import { toast } from 'react-toastify'
import Spinner from '../../Shared/Spinner'
import { InputField, NullableInput } from "../../Shared/InputField";
import { months_list } from "../../Shared/List";

const Payment = () => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState(false)

    const navigate = useNavigate()
    const location = useLocation()
    const current_user = JSON.parse(localStorage.getItem('user'));

    const [formData, setFormData] = useState({
        location_id: "",
        full_name: "",
        contact_number: "",
        address: "",
        previous_balance: "",
        bill: "",
        prepaid: "",
        current_balance: "",
        paid: "",
        discount: "",
        balance: "",
        page: "",
        date: new Date().toISOString().slice(0, 10),
        remark: "",
        book: "",
        year: "",
        month: "",
    })
    const {location_id, full_name, contact_number, address, previous_balance, bill, current_balance, paid, prepaid, discount, balance, page, date, remark, book, year, month} = formData


    useEffect(() => {
        if (location.state){
            const { payload } = location.state
            setFormData((prevState) => ({
                ...prevState,
                book: payload.book,
                year: payload.year,
                month: payload.month,
                page: payload.page,
            }))
            setTitle(`${months_list[payload.month - 1].name} ${payload.year}, Payment Form`)
        }
        
    }, [])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))        
    }

    const paidKeyUp = (e) => {
        if (parseFloat(e.target.value) > current_balance){
            setFormData((prevState) => ({
                ...prevState,
                balance: (current_balance - parseFloat(e.target.value)).toFixed(2),
            }))
            document.getElementById('discount').setAttribute("disabled", "disabled");
        } else if (parseFloat(e.target.value) < current_balance && current_user.enable_discount != "No"){
            setFormData((prevState) => ({
                ...prevState,
                balance: (current_balance - parseFloat(e.target.value)).toFixed(2),
            }))
            document.getElementById('discount').removeAttribute("disabled");
        }else {
            setFormData((prevState) => ({
                ...prevState,
                balance: (current_balance - parseFloat(e.target.value)).toFixed(2)
            }))

            document.getElementById('discount').setAttribute("disabled", "disabled");
        }
    }

    const DiscountKeyUp = (e) => {
        if ((parseFloat(e.target.value) + parseFloat(paid)) > current_balance){
            setFormData((prevState) => ({
                ...prevState,
                balance: current_balance,
                paid: 0.00,
                discount: 0.00,
            }))
            document.getElementById('discount').setAttribute("disabled", "disabled");
        }else{
            setFormData((prevState) => ({
                ...prevState,
                balance: (current_balance - (parseFloat(e.target.value) + parseFloat(paid))).toFixed(2)
            }))
        }
    }

    const onBlur = (e) => {
        const payload = {location_id, year, month}
        getBillDetail(payload)
    }

    const getBillDetail = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payments/payment-detail', payload)
            if (response.status === 200){
                setErrors({})
                if (response.data.detail){
                    setErrors({
                        location_id: response.data.detail
                    })
                }else{
                    setFormData((prevState) => ({
                        ...prevState,
                        full_name: response.data.full_name,
                        contact_number: response.data.contact_number,
                        address: response.data.address,
                        previous_balance: response.data.previous_balance,
                        bill: response.data.bill,
                        prepaid: response.data.prepaid,
                        current_balance: parseFloat(response.data.current_balance),
                        discount: 0.00,
                        balance: parseFloat(response.data.current_balance)
                    }))
                }
                // console.log(response.data)
                setIsLoading(false)
            }else{
                toast.error('unknown error occurred.')
            }
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }

    const onSubmit = (e) => {
        e.preventDefault()
        
        //find category name with its index
        const payload = {location_id, paid, discount, year, month, book, page, date, remark}
        processPayment(payload)
        
    }

    const processPayment = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.post('/payments/process-payment', payload)
            toast.success("Payment processed susccessfully")
            setFormData({
                location_id: "",
                full_name: "",
                contact_number: "",
                address: "",
                previous_balance: "",
                bill: "",
                prepaid: "",
                current_balance: "",
                paid: "",
                discount: "",
                balance: "",
                date: new Date().toISOString().slice(0, 10),
                remark: "",
                book: book,
                page: response.data.page,
                year: year,
                month: month,
            })
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response?.data?.detail)
            }
        }
    }


    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
    
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Location ID"
                                name="location_id"
                                type="text"
                                required="required"
                                label="ID"
                                onBlur={onBlur}
                                value={location_id}
                                onChange={onChange}
                                error={errors.location_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Customer FullName"
                                disabled="disabled"
                                name="full_name"
                                type="text"
                                required="required"
                                label="FullName"
                                value={full_name}
                                onChange={onChange}
                                error={errors.full_name}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Contact Number"
                                name="contact_number"
                                disabled="disabled"
                                type="text"
                                required="required"
                                label="Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="previous_balance"
                                type="text"
                                required="required"
                                disabled="disabled"
                                label="Previous Balance"
                                value={previous_balance}
                                onChange={onChange}
                                error={errors.previous_balance}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-2">
                            <InputField
                                name="bill"
                                type="number"
                                required="required"
                                disabled="disabled"
                                label="Bill"
                                value={bill}
                                onChange={onChange}
                                error={errors.bill}
                            />
                        </div>
                        <div className="col-md-2">
                            <InputField
                                name="prepaid"
                                type="number"
                                required="required"
                                disabled="disabled"
                                label="PrePaid"
                                value={prepaid}
                                onChange={onChange}
                                error={errors.prepaid}
                            />
                        </div>
                        <div className="col-md-2">
                            <InputField
                                name="current_balance"
                                type="number"
                                required="required"
                                disabled="disabled"
                                label="Current Balance"
                                value={current_balance}
                                onChange={onChange}
                                error={errors.current_balance}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Paid Amount"
                                name="paid"
                                type="text"
                                required="required"
                                label="Paid"
                                value={paid}
                                onKeyUp={paidKeyUp}
                                onChange={onChange}
                                error={errors.paid}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Discount if any"
                                name="discount"
                                id="discount"
                                disabled="disabled"
                                type="text"
                                required="required"
                                label="Discount"
                                value={discount}
                                onKeyUp={DiscountKeyUp}
                                onChange={onChange}
                                error={errors.discount}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Current Balance"
                                name="balance"
                                disabled="disabled"
                                type="text"
                                required="required"
                                label="Balance"
                                value={balance}
                                onChange={onChange}
                                error={errors.balance}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Book Cover Number"
                                name="book"
                                type="text"
                                required="required"
                                label="Book"
                                value={book}
                                onChange={onChange}
                                error={errors.book}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Page Number"
                                name="page"
                                type="text"
                                required="required"
                                label="Page"
                                value={page}
                                onChange={onChange}
                                error={errors.page}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                name="date"
                                type="date"
                                required="required"
                                label="Transaction Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <NullableInput
                                placeholder="Payment Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-info" value="Save" style={{float: 'right'}}/>
                        </div>
                    </div>
                    <br/>
                </form>
            </div>
        </div>
      <br/>
    </>
  )
}

export default Payment